import { SortOption } from "../types";

export const makeSortableHeaderOption = <T extends string>(
  key: T,
  dictionary?: Partial<Record<T, string>>
): SortOption => ({
  value: key,
  label: dictionary?.[key] || key,
});
